module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serverisnotavailable-panel-wrapper"
  }, [_c('div', {
    staticClass: "serverisnotavailable-panel"
  }, [_c('div', {
    staticClass: "serverisnotavailable-header"
  }, [_c('span', {
    staticClass: "serverisnotavailable-app-title"
  }, [_vm._v(_vm._s(_vm.appSettings.appName))]), _vm._v(" "), _c('span', {
    staticClass: "serverisnotavailable-text-title"
  }, [_vm._v(_vm._s(_vm.i18n.serverIsNotAvailable.title))]), _vm._v(" "), _c('span', {
    staticClass: "serverisnotavailable-text"
  }, [_vm._v(_vm._s(_vm.i18n.serverIsNotAvailable.text) + " " + _vm._s(_vm.appSettings.server.host))])]), _vm._v(" "), _c('Button', {
    staticClass: "serverisnotavailable-try-recconect-button no-circle",
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.tryToConnectToServer
    }
  }, [_vm._v(_vm._s(_vm.i18n.serverIsNotAvailable.tryReconnectButtonText))]), _vm._v(" "), _c('Button', {
    staticClass: "serverisnotavailable-try-recconect-button no-circle",
    attrs: {
      "type": "ghost",
      "size": "large"
    },
    on: {
      "click": _vm.returnToWelcomePage
    }
  }, [_vm._v("Вернуться на главную страницу")]), _vm._v(" "), (_vm.activeUser != null) ? _c('div', [_c('span', {
    staticClass: "serverisnotavailable-logout-text",
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.serverIsNotAvailable.logoutText)
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "no-circle",
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        _vm.appStateServerConnectedSet(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n.login.signout))])], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0553cd99","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonPages/ServerIsNotAvailable.vue
// module id = 363
// module chunks = 0